import { render, staticRenderFns } from "./PotentialOffer.vue?vue&type=template&id=6b12ee82"
import script from "./PotentialOffer.vue?vue&type=script&lang=js"
export * from "./PotentialOffer.vue?vue&type=script&lang=js"
import style0 from "./PotentialOffer.vue?vue&type=style&index=0&id=6b12ee82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports